import { render, staticRenderFns } from "./FormTemplate.vue?vue&type=template&id=5d897ec5&scoped=true&"
import script from "./FormTemplate.vue?vue&type=script&lang=ts&"
export * from "./FormTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./FormTemplate.vue?vue&type=style&index=0&id=5d897ec5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d897ec5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VDivider,VProgressLinear,VRow})
